export default {
  user: state => state.user,
  users: state => state.users,
  roles: state => state.roles,
  pageSize: state => state.pageSize,
  searchTerm: state => state.searchTerm,
  retrospectiveDay: state => state.retrospectiveDay,
  filterOptions: state => state.filterOptions,
  filterBy: state => state.filterBy,
  sortDir: state => state.sortDir,
  orderBy: state => state.orderBy,
  isUserChecked: state => state.isUserChecked,
  firmName: state => state.firmName
}



// WEBPACK FOOTER //
// ./src/store/modules/users/getters.js